import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  ExecuteProcessorMutation,
  ExecuteProcessorMutationVariables,
} from '#graphql/generated';

export const EXECUTE_PROCESSOR: TypedDocumentNode<
  ExecuteProcessorMutation,
  ExecuteProcessorMutationVariables
> = gql`
  mutation ExecuteProcessor($input: ExecuteProcessorInput!) {
    executeProcessor(input: $input) {
      success
      error
      result
      instanceId
    }
  }
`;
